import EditPostContainer from "./EditPostContainer";
export default EditPostContainer;
